import { ComponentPropsWithoutRef } from 'react';

export default function ArrowDown(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      {...props}
      version="1.1"
      viewBox="0 0 70 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0 L30 32 L60 0" />
    </svg>
  );
}
